export default __webpack_public_path__ + "static/media/biscuit.036204c4.jpg";